//open first tab on desktop on load.
if (window.innerWidth > 750) {
  const currentUrl = window.location.href;
  if(currentUrl.includes("custom")){
    document
      .querySelectorAll(".accordian-item-header")[3]
      .classList.add("active");
  } else {
    document
      .querySelectorAll(".accordian-item-header")[0]
      .classList.add("active");
  }
  document.querySelectorAll(".accordian-item-header").forEach((header) => {
    const body = header.nextElementSibling;
    if (header.classList.contains("active")) {
      body.style.maxHeight = body.scrollHeight + "px";
    }
  });
}

document.querySelectorAll(".accordian-item-header").forEach((header) => {
  header.addEventListener("click", (event) => {
    const activeTab = document.querySelector(".active.accordian-item-header");
    if (activeTab && activeTab !== header) {
      activeTab.classList.toggle("active");
      activeTab.nextElementSibling.style.maxHeight = 0;
    }
    header.classList.toggle("active");
    const body = header.nextElementSibling;
    if (header.classList.contains("active")) {
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = 0;
    }
  });
});
